export default __webpack_public_path__ + "static/media/madlib1.9197a02b.png";